import {
  order,
  order_status,
  order_detail
} from '@/api/pay'
const exam = {
  state: {},
  mutations: {

  },
  actions: {
    /**
     * 获取考试试卷
     * @param {*} context 
     * @param {*} data 
     */
    order({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        order(params).then(response => {
          const {
            data
          } = response;

          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },


    /**
     * 查询支付状态
     * @param {*} context 
     * @param {*} data 
     */
    order_status({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        order_status(params).then(response => {
          const {
            data
          } = response;

          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },


    /**
     * 查询课程
     * @param {*} context 
     * @param {*} data 
     */
    order_detail({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        order_detail(params).then(response => {
          const {
            data
          } = response;

          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },



  }

}

export default exam



// WEBPACK FOOTER //
// ./src/store/modules/pay.js